<template>
	<div style="overflow: hidden;height: 100vh;margin-left: 0px;margin-right: 0px;background: #F4F8FF">
		<div style="margin-bottom: 22px;margin-top: 30px;display: flex;align-items: center;padding:0 16px;">
			<div style="flex: 1;display: flex;align-items: center;">
				<div style="font-size: 14px;color: #0F1A3A;  opacity: 0.5;">{{ $t('巡检.车辆巡检') }}</div>
				<img :src="imgIcArrowRight" style="width: 24px;height: 24px;" />
				<div style="font-size: 14px;color: #0F1A3A;">{{ $t('巡检.巡检详情') }}</div>
			</div>
			<el-button type="primary" @click="onClose" size="small">{{ $t('driver.返回') }}</el-button>
		</div>
		<div style="height: calc(100% - 100px);">
			<el-row style="height: 100%;">
				<el-col :span="12" style="height: 100%;">
					<div class="leftclass" style="height: 100%;overflow: hidden;">
						<div style="background: #FFFFFF;">
							<div style="font-size: 14px;font-weight: 600;    text-align: left;margin: 20px 20px;">
								{{ $t('龙翼简报.车辆信息') }}
							</div>
							<el-form ref="form" :model="form" :label-width="LanguageId == 1 ? '80px' : '135px'"
								style="margin: 20px 20px;" disabled="true">
								<el-form-item :label="$t('行程统计.车辆')">
									<el-input v-model="form.CarNo"></el-input>
								</el-form-item>
								<el-form-item :label="$t('巡检.巡检人')">
									<el-input v-model="form.OPTName"></el-input>
								</el-form-item>
								<el-form-item :label="$t('巡检.巡检时间')">
									<el-input v-model="form.InspectionTime"></el-input>
								</el-form-item>
							</el-form>
						</div>
						<div style="background: #FFFFFF;margin-top:20px" class="right-scroll-container">
							<div style="font-size: 14px;font-weight: 600;    text-align: left;margin: 20px 20px;">
								{{ $t('failure.faultDetail') }}
							</div>
							<div class="fault-detail-container">
								<div v-if="abnormalList.length > 0">
									<div v-for="(abnormal, idx) in abnormalList" :key="idx"
										style="display: flex; flex-direction:row;margin-top:20px;margin:20px 32px 20px 20px;align-items: end;">

										<img src="../../../assets/images/icon_fault_1.png"
											style="width: 20px;height: 20px;margin:0px 4px;" />
										<span style="font-size: 14px; font-weight: 500; color: #0E193B;">{{
											abnormal.name }}</span>
										<div
											style="margin-left: 30px; font-size: 12px; font-weight: 400; color: #0E193B;">
											{{ abnormal.FaultDescription || '无异常详情描述' }}
										</div>
									</div>
								</div>
								<div v-else style="margin: 40px 32px; font-size: 12px; color: #999;">
									{{ $t('巡检.无故障详情信息') }}
								</div>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="12" style="height: 100%;">
					<div class="right-scroll-container" style="height: 100%;margin:0 40px 0 20px;background: #FFFFFF;">
						<!-- 标题和结果 -->
						<div style="margin: 20px;display:flex;justify-content: space-between;align-items: center;">
							<span style="font-size: 14px;font-weight: 600;">{{ inspectionTitle }}</span>
							<span :style="{
								fontSize: '14px',
								fontWeight: '600',
								color: inspectionResult === 0 ? '#07B477' : '#FF106E'
							}">
								{{ inspectionResult === 0 ? $t('vehicletrack.normal') : $t('巡检.异常') + `${abnormalCount}`
								}}
							</span>
						</div>

						<!-- 1. 智能巡检（原逻辑不变） -->
						<div v-if="flag === 0">
							<div v-for="(system, index) in systemList" :key="index" style="margin-bottom: 20px;">
								<!-- 智能巡检分组标题 -->
								<div style="margin-left:32px;display: flex;align-items: center;">
									<div style="width: 3px;height: 16px;background: #2A7AFF;border-radius: 1px;"></div>
									<span style="font-size: 14px;font-weight: 600;margin-left:7px">{{ system.name
										}}</span>
								</div>
								<!-- 智能巡检详情项 -->
								<div v-for="(detail, detailIndex) in system.details" :key="detailIndex"
									style="margin: 10px 40px;display:flex;justify-content: space-between;align-items: center;">
									<span :style="{
										fontSize: '12px',
										color: detail.result === 1 ? '#FF106E' : '#0E193B'
									}">{{ detail.name }}</span>
									<div
										:style="{ width: '8px', height: '8px', borderRadius: '50%', background: detail.result === 1 ? '#FF106E' : '#07B477' }">
									</div>
								</div>
							</div>
						</div>

						<!-- 2. 外观巡检（修复后逻辑） -->
						<div v-else>
							<!-- 外观巡检分组列表：如果无数据，显示提示 -->
							<div v-if="groupedExData.length === 0"
								style="margin: 40px;text-align: center;color: #999;font-size: 12px;">
								{{ $t('巡检.暂无外观巡检数据') }}
							</div>
							<!-- 有数据则渲染分组 -->
							<div v-else>
								<div v-for="(group, groupIndex) in groupedExData" :key="groupIndex"
									style="margin-bottom: 25px;">
									<!-- 外观巡检分组标题（如：灯光车身、后舱、底盘） -->
									<div style="margin-left:32px;display: flex;align-items: center;">
										<div style="width: 3px;height: 16px;background: #2A7AFF;border-radius: 1px;">
										</div>
										<span
											style="font-size: 14px;font-weight: 600;margin-left:7px;color: #0E193B;">{{
												group.title }}</span>
									</div>
									<!-- 分组下的详情项（如：灯光、门窗线锁） -->
									<div v-for="(detail, detailIndex) in group.details" :key="detailIndex"
										style="margin: 10px 40px;display:flex;justify-content: space-between;align-items: center;">
										<span :style="{
											fontSize: '12px',
											color: detail.InspectionResult === 1 ? '#FF106E' : '#0E193B',
											maxWidth: '80%',
											wordBreak: 'break-all'
										}">{{ detail.Title }}</span>
										<div :style="{
											width: '8px',
											height: '8px',
											borderRadius: '50%',
											background: detail.InspectionResult === 1 ? '#FF106E' : '#07B477'
										}"></div>
									</div>
								</div>
								<div style="margin:30px">
									<el-divider></el-divider>
								</div>

								<!-- 备注图片：如果有图片则显示 -->
								<div v-if="exteriorImages.length > 0"
									style="margin: 20px 40px;display: flex;justify-content: space-between;">
									<div style="font-size: 14px;font-weight: 600;margin-bottom: 10px;color: #0E193B;">
										{{ $t('路费.备注图片') }}</div>
									<div style="display: flex;flex-wrap: wrap;gap: 10px;">
										<div v-for="(img, imgIndex) in exteriorImages" :key="imgIndex"
											style="width: 80px;height: 80px;border: 1px solid #F4F8FF;border-radius: 4px;overflow: hidden;">
											<!-- 直接使用数组中已拼接好的完整路径 -->
											<img :src="img" style="width: 100%;height: 100%;object-fit: cover;"
												@error="handleImgError($event)">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import settings from "@/settings";
import language from '@/utils/getLanguageId';
import imgIcArrowRight from "@/assets/images/ic_arrow_right.png";
export default {
	data() {
		return {
			imgIcArrowRight,
			form: {
				name: ""
			},
			systemList: [], // 智能巡检原始数据
			groupedExData: [], // 外观巡检分组后数据
			inspectionResult: null, // 整体巡检结果（0正常/1异常）
			abnormalList: [], // 异常项列表
			inspectionTitle: "",
			flag: 0,
			exteriorImages: [], // 备注图片路径数组
			abnormalCount: 0, // 异常数量
			LanguageId: 1,
		}
	},
	mounted() {
		const inspectionData = JSON.parse(this.$route.query.inspectionData || '{}');
		console.log("接收到的巡检数据:", inspectionData);
		this.LanguageId = language(this.$store.getters.locale)
		this.form = inspectionData;
		this.inspectionResult = inspectionData.Result; // 保存整体巡检结果

		this.inspectionTitle = inspectionData.InspectionType === 0 ? this.$t('巡检.智能巡检') : this.$t('巡检.外观巡检');
		this.flag = inspectionData.InspectionType;
		console.log("flag最终值：", this.flag);
		if (inspectionData.InspectionType === 0) {
			this.getdata(inspectionData.OperationID);
		} else {
			this.getExdata(inspectionData.OperationID);
		}
	},
	methods: {
		onClose() {
			this.$emit('onClose');
			this.$router.go(-1);
		},
		getdata(OperationID) {
			this.$api.queryInspectionRecordDetails({
				"OperationID": OperationID,
			}).then((res) => {
				console.log("智能巡检详情接口返回:", res);
				if (res && res.data && Array.isArray(res.data)) {
					this.systemList = res.data;
					this.filterAbnormalItems(res.data);
				} else {
					console.warn("接口返回的数据格式不正确:", res);
					this.systemList = [];
					this.abnormalList = [];
					this.abnormalCount = 0;
				}
			}).catch(error => {
				console.error("获取智能巡检详情失败:", error);
				this.systemList = [];
				this.abnormalList = [];
				this.abnormalCount = 0;
			});
		},
		getExdata(OperationID) {
			this.$api.queryInspectionRecordDetailsEx({
				"OperationID": OperationID,
			}).then((res) => {
				console.log("外观巡检详情接口返回:", res);
				if (res && res.data && Array.isArray(res.data)) {
					// 处理备注图片：拼接baseUrl + 移除longyi/ + 过滤空值
					if (res.ExteriorImage) {
						this.exteriorImages = res.ExteriorImage
							.split(';') // 按分号分割成数组
							.map(imgPath => {
								// 1. 移除路径中的"longyi/"；2. 拼接settings.baseUrl
								return `${settings.baseUrl}${imgPath.replace('longyi/', '')}`;
							})
							.filter(img => img); // 过滤空字符串，避免无效路径
					}
					// 其他逻辑不变
					this.groupedExData = this.groupExData(res.data);
					this.filterAbnormalItemsForEx(res.data);
				} else {
					// 错误处理不变
					this.groupedExData = [];
					this.abnormalList = [];
					this.exteriorImages = [];
					this.abnormalCount = 0;
				}
			}).catch(error => {
				// 异常处理不变
				console.error("获取外观巡检详情失败:", error);
				this.groupedExData = [];
				this.abnormalList = [];
				this.exteriorImages = [];
				this.abnormalCount = 0;
			});
		},
		// 分组外观巡检数据
		groupExData(data) {
			const groups = {};
			data.forEach(item => {
				if (item.PItemID === 0) {
					// PItemID为0的作为组标题
					groups[item.ItemID] = {
						title: item.Title,
						details: []
					};
				} else if (groups[item.PItemID]) {
					// 将PItemID相同的放入对应组
					groups[item.PItemID].details.push(item);
				}
			});
			// 转换为数组
			return Object.values(groups);
		},
		// 智能巡检：筛选异常项 + 统计数量
		filterAbnormalItems(systemData) {
			const abnormalDetails = systemData.reduce((acc, system) => {
				const abnormal = system.details.filter(detail => detail && detail.result === 1) || [];
				return acc.concat(abnormal);
			}, []);
			this.abnormalList = abnormalDetails;
			this.abnormalCount = abnormalDetails.length; // 统计异常数量
			console.log("智能巡检筛选后的异常项:", this.abnormalList);
		},
		// 外观巡检：筛选异常项 + 统计数量

		filterAbnormalItemsForEx(data) {
			// 筛选条件：InspectionResult=1 且 PItemID≠0（排除分组标题）
			const abnormalItems = (data || []).filter(item => {
				return item &&
					item.InspectionResult === 1 &&
					item.PItemID !== 0; // 核心新增条件
			});
			this.abnormalList = abnormalItems.map(item => ({
				name: item.Title || '',
				FaultDescription: item.FaultDescription || this.$t('巡检.无异常详情描述')
			}));
			this.abnormalCount = abnormalItems.length; // 统计符合条件的异常数
		},
		// 图片加载失败回调
		handleImgError(e) {
			// 可添加默认错误图逻辑，如：e.target.src = require('@/assets/error-img.png');
		}
	}
}
</script>

<style lang="scss" scoped>
.leftclass {
	display: flex;
	flex-direction: column;
	margin: 0px 40px;
}

.right-scroll-container {
	overflow-y: auto;
	/* 添加垂直滚动条 */
	padding-right: 8px;
	/* 为滚动条留出空间 */
}

/* 自定义滚动条样式 */
.right-scroll-container::-webkit-scrollbar {
	width: 6px;
}

.right-scroll-container::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 3px;
}

.right-scroll-container::-webkit-scrollbar-thumb {
	background: #c1c1c1;
	border-radius: 3px;
}

.right-scroll-container::-webkit-scrollbar-thumb:hover {
	background: #a8a8a8;
}
</style>